// reducer.js
import * as actionTypes from "../../actionLabels/index";

const initialState = {
  loading: false,
  bidHistoryData: [],
  viewBidHistoryData: [],
  error: null,
  viewLoading: false,
  dropdownData: [],
  exportData: [],
};

const bidHistoryReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.FETCH_BID_HISTORY_REQUEST:
      return {
        ...state,
        loading: action.payload.isExport == 1 ? false : true,
        error: null,
      };
    case actionTypes.FETCH_BID_HISTORY_SUCCESS:
      return {
        ...state,
        loading: false,
        bidHistoryData: action.payload,
        error: null,
      };
    case actionTypes.FETCH_BID_HISTORY_FAILURE:
      return {
        ...state,
        loading: false,
        bidHistoryData: [],
        error: action.payload,
      };
    case actionTypes.VIEW_BID_HISTORY_REQUEST:
      return {
        ...state,
        viewLoading: true,
        error: null,
      };
    case actionTypes.VIEW_BID_HISTORY_SUCCESS:
      return {
        ...state,
        viewLoading: false,
        viewBidHistoryData: action.payload,
        error: null,
      };
    case actionTypes.VIEW_BID_HISTORY_FAILURE:
      return {
        ...state,
        viewLoading: false,
        viewBidHistoryData: null,
        error: action.payload,
      };
    case actionTypes.FETCH_BID_HISTORY_DROPDOWN_SUCCESS:
      return {
        ...state,
        dropdownData: action.payload,
      };
    case actionTypes.FETCH_BID_HISTORY_DROPDOWN_FAILURE:
      return {
        ...state,
        error: action.payload,
        dropdownData: [],
      };
    case actionTypes.BID_HISTORY_EXPORT:
      return {
        ...state,
        exportData: action.payload,
      };
    default:
      return state; // Ensure the default state is returned
  }
};

export default bidHistoryReducer;
